import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { removeSessionCookie } from '@clearscore/helpers.cookies';
import { actions as sessionActions, selectors as sessionSelectors } from '@clearscore/redux.session';
import connect from '@clearscore/redux.connect';
import withVertical from '@shared/webapp-vertical';
import Container from '@clearscore/rainbow.container';

import reducer from './lib/reducers';
import epics from './lib/epics';
import middleware from './lib/middleware';
import appBridgeTypes from './lib/appBridgeTypes';
import ScreenVerify from './components/screen-verify';
import LoginForm from './components/login-form/container';

const Login = ({ history }) => {
    const dispatch = useDispatch();
    const userHasSession = !!useSelector(sessionSelectors.getSessionToken);

    useEffect(() => {
        if (userHasSession) {
            dispatch(sessionActions.clearSession());
            removeSessionCookie();
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <Container size={Container.sizes.SMALL}>
            <Switch>
                <Route path="*/verify" component={ScreenVerify} />
                <Route path="*" render={() => <LoginForm history={history} />} />
            </Switch>
        </Container>
    );
};

Login.propTypes = {
    history: PropTypes.object.isRequired,
};

const ConnectedComponent = connect(null, null, { useRouter: true })(Login);

export default withVertical(ConnectedComponent, {
    name: 'login',
    reducer,
    epics,
    middleware,
    appBridgeTypes,
});
